module.exports = __webpack_public_path__ + "resources/img/img_codesign1_m.d3bbd22c5709155f3c9478458662b6b0.png";